import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'chartjs-adapter-date-fns';
import Map from 'ol/Map';
import View from 'ol/View';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { defaults as defaultControls } from "ol/control";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import LayerSwitcher from "ol-ext/control/LayerSwitcher";
import { Style, Fill, Stroke, Circle } from 'ol/style';
import Text from "ol/style/Text.js";
import FillPattern from "ol-ext/style/FillPattern";
import Select from "ol/interaction/Select";
import ControlBar from "ol-ext/control/Bar";
import Dialog from "ol-ext/control/Dialog";
import Button from "ol-ext/control/Button";
import GeoJSON from 'ol/format/GeoJSON';
import Overlay from 'ol/Overlay';
// import Chart from 'chart.js/auto';
import * as echarts from 'echarts';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { intersects } from 'ol/extent';
import { fromLonLat, transform } from "ol/proj";
import { fetchSources, fetchLayers, fetchFeatures, fetchDataUnits, fetchSourceParameters, fetchSensorsById, fetchSensorData, fetchDataStates, updateLayers } from '../services/api';
import logger from '../logger';
import ScaleLine from 'ol/control/ScaleLine';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import XYZ from "ol/source/XYZ";
import LayerSwitcherImage from "ol-ext/control/LayerSwitcherImage";
import SideBar from './SideBar';
import "../App.css";



const Monitoring = () => {
  const [location, setLocation] = useState({
    longitude: 11.028995965569194,
    latitude: 46.05321545463036,
  });
  const [sources, setSources] = useState([]);
  const [layers, setLayers] = useState([]);
  const [layersState, setLayersState] = useState([]);
  const [features, setFeatures] = useState([]);
  const [states, setStates] = useState([])
  const [projections, setSourceParameters] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('access'));
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [hoveredButtonInfo, setHoveredButtonInfo] = useState('<strong>Hover over a button to see its details</strong>'); // State for hover information
  const [hoverLock, setHoverLock] = useState(false); // State to lock hover info
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(true);
  const [isInitializing, setIsInitializing] = useState(true);



  const mapRef = useRef();
  const selectToViewRef = useRef(null);
  const controlBarRef = useRef(null);
  const showDialogRef = useRef(false);
  const hoverLockRef = useRef(false);  // Use a ref to track hover lock state
  const selectedDateRef = useRef(new Date().toISOString().split('T')[0]);
  const layerSwitcherRef = useRef(null);

  // const createdCharts = useRef(new Set());

  const updateHoverButtonInfo = (content, forceUpdate = false) => {
    // Use showDialogRef for immediate access to dialog state
    if (!hoverLockRef.current || forceUpdate) {
        if (!showDialogRef.current) {  // Prevent updating hover info if dialog is open
            setHoveredButtonInfo(content);
        }
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen((prevState) => {
      const newState = !prevState;
      ////logger.log("is drawer open: ", newState);
      return newState;
    });
  };


  useEffect(() => {
    // Create Initialization Element
    const initElement = document.createElement('div');
    initElement.id = 'init-element';
    initElement.style.position = 'fixed'; // Attach to the viewport
    initElement.style.top = '0';
    initElement.style.left = '0';
    initElement.style.height = '100vh'; // Full viewport height
    initElement.style.width = '100vw';  // Full viewport width
    initElement.style.zIndex = '10000'; // Ensure it's above everything
    initElement.style.backgroundColor = 'rgba(56, 65, 81, 0.4)'; // Semi-transparent background
    initElement.style.color = 'white';
    initElement.style.display = 'flex';
    initElement.style.alignItems = 'center';
    initElement.style.justifyContent = 'center';
    initElement.style.flexDirection = 'column';
    initElement.innerHTML = `
      <div class="loader"></div>
      <p style="margin-top: 10px;">Initializing...</p>
    `;
    document.body.appendChild(initElement);
  
    // Remove After 5 Seconds
    const timer = setTimeout(() => {
      setIsInitializing(false);
      document.body.removeChild(initElement);
    }, 6000);
  
    // Cleanup to avoid memory leaks
    return () => {
      clearTimeout(timer);
      if (document.body.contains(initElement)) {
        document.body.removeChild(initElement);
      }
    };
  }, []);

  // Monitor `showDialog` state to control hover behavior and locking
  useEffect(() => {
      if (showDialog) {
          setHoverLock(true);
          hoverLockRef.current = true;  // Use ref to immediately reflect hover lock
          showDialogRef.current = true;  // Update showDialogRef when dialog is shown
      } else {
          setHoverLock(false);
          hoverLockRef.current = false; // Unlock hover immediately
          showDialogRef.current = false; // Update showDialogRef when dialog is hidden
      }
  }, [showDialog]);

  const combineSourcesWithCategories = async () => {
    try {
        const sources = await fetchSources();  // Replace with your own sources fetching logic
        const parameters = await fetchSourceParameters();  // Replace with your API for source parameters
    
        const projectionMap = parameters.projection_systems.reduce((map, proj) => {
        map[proj.id] = proj.title;
        return map;
        }, {});
    
        const sourceTypeMap = parameters.source_types.reduce((map, type) => {
        map[type.id] = { title: type.title, options: type.options };
        return map;
        }, {});
    
        return sources.map(source => {
        const projection = projectionMap[source.projection];
        const sourceType = sourceTypeMap[source.type];
        const sourceOptions = source.options.reduce((acc, option) => {
            acc[option.title] = option.value;
            return acc;
        }, {});
    
        return {
            ...source,
            projection,
            sourceType,
            sourceOptions,
        };
        }).filter(source => source !== null);
    
    } catch (error) {
        ////logger.error('Error combining sources:', error);
        throw error;
    }
  };

  const assignTileLayerToLayerSwitcherImage = (combinedSources, map) => {
    combinedSources
        .filter(source => source.is_enabled)
        .forEach(source => {
            let layer = null;
            if (source.sourceType.title.includes('Tile')) {
                layer = new TileLayer({
                    source: new XYZ({
                        url: source.sourceOptions.url,
                        tileSize: parseInt(source.sourceOptions.tileSize) || 256,
                        attributions: source.attribution,
                    }),
                    title: source.title,
                    visible: false,
                    displayInLayerSwitcherImage: true,
                    displayInLayerSwitcher: false,
                });
            }
            
            // Check if the layer was created correctly before adding it to the map
            if (layer) {
                map.addLayer(layer);
            } 
            // else {
            //     ////logger.error(`Failed to create layer for source: ${source.title}`);
            // }
    });
  };

  // Fetch all data in parallel using async/await
  const fetchAllData = async () => {
    try {
      const [sourcesResponse, layersResponse, featuresResponse, sourceParamsResponse, statesResponse] = await Promise.all([
        fetchSources(),
        fetchLayers(),
        fetchFeatures(),
        fetchSourceParameters(),
        fetchDataStates(),
      ]);

      // Set the responses into their respective states
      setSources(sourcesResponse);
      setLayers(layersResponse);
      setFeatures(featuresResponse);
      setSourceParameters(sourceParamsResponse);
      setStates(statesResponse);

      ////logger.log('Sources fetched:', sourcesResponse);
      ////logger.log('Layers fetched:', layersResponse);
      ////logger.log('Features fetched:', featuresResponse);
      ////logger.log('Source Parameters fetched:', sourceParamsResponse);
      ////logger.log('States fetched:', statesResponse);

      // Mark data as fetched
      setDataFetched(true);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  library.add(fas, far, fab);

  function getFaUnicode(faClass) {
    // Split the class string into an array of individual class names
    const classParts = faClass.split(' ');

    // Find the style prefix (e.g., 'fas', 'far', 'fab')
    const stylePrefix = classParts.find(part => part.startsWith('fas') || part.startsWith('far') || part.startsWith('fab'));

    // Find the icon name part (e.g., 'fa-user') and remove the 'fa-' prefix
    const iconNamePart = classParts.find(part => part.startsWith('fa-') && part !== stylePrefix);

    // Check if we found a valid style prefix and icon name
    if (!stylePrefix || !iconNamePart) {
        return '';  // Return an empty string if the class string is invalid
    }

    const iconName = iconNamePart.replace('fa-', '');
    ////logger.log("icon name: ", iconName);
    // Determine the correct library based on the style
    const styleMap = {
        'fas': 'fas',
        'far': 'far',
        'fab': 'fab',
    };

    const style = styleMap[stylePrefix];

    const iconDefinition = library.definitions[style][iconName];

    if (iconDefinition) {
        return String.fromCharCode(parseInt(iconDefinition[3], 16)).toLowerCase();
    }


    ////logger.error(`Icon "${iconName}" not found in style "${style}".`);
    return ''; // Return an empty string if the icon is not found
  }

  const getLineDash = (line) => {
    let lineDash = [];
    
    switch (line) {
      case 'dashed':
        lineDash = [10, 5]; // 10px dashes with 5px gaps
        break;
      case 'dotted':
        lineDash = [2, 2];  // 2px dashes with 2px gaps
        break;
      case 'solid':
      default:
        lineDash = []; // Solid line
        break;
    }
    
    return lineDash;
  }

  const createStyleFromLayer = (layer, states) => {
    ////logger.log("Layer For Styling: ", layer);
  
    const fillColor = layer.background || 'rgba(255, 255, 255, 0.6)';
    const patternColor = layer.color || '#319FD3';
    const pattern = layer.pattern || 'none';
    const faClass = layer.icon;
    const unicodeChar = getFaUnicode(faClass);
    const lineDash = getLineDash(layer.line);
  
    ////logger.log("fillColor: ", fillColor);
    ////logger.log("patternColor: ", patternColor);
    ////logger.log("pattern: ", pattern);
    ////logger.log("faClass: ", faClass);
    ////logger.log("unicodeChar: ", unicodeChar);
    ////logger.log("lineDash: ", lineDash);
  
    return function (feature) {
      ////logger.log("States in styling:", states);

      if (!states || states.length === 0) {
        ////logger.warn("States are undefined or empty, applying default styling.");
  
        const geometryType = feature.getGeometry().getType();
  
        switch (geometryType) {
          case 'Point':
          case 'MultiPoint':
            return new Style({
              image: new Circle({
                radius: 13,
                fill: new Fill({
                  color: fillColor,
                }),
                stroke: new Stroke({
                  color: patternColor,
                  width: 2,
                  lineDash: lineDash,
                }),
              }),
              text: new Text({
                text: unicodeChar,
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: patternColor,
                }),
              }),
            });
  
          case 'LineString':
          case 'MultiLineString':
            return new Style({
              stroke: new Stroke({
                color: patternColor,
                width: 4,
                lineDash: lineDash,
              }),
            });
  
          case 'Polygon':
          case 'MultiPolygon':
            return new Style({
              fill: new FillPattern({
                pattern: pattern,
                color: patternColor,
                fill: new Fill({
                  color: fillColor,
                }),
                size: 10,
                width: 1,
              }),
              stroke: new Stroke({
                color: patternColor,
                width: 2,
                lineDash: lineDash,
              }),
              text: new Text({
                text: unicodeChar,
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: patternColor,
                }),
              }),
            });
  
          default:
            return new Style({
              fill: new Fill({
                color: fillColor,
              }),
              stroke: new Stroke({
                color: patternColor,
                width: 2,
              }),
              text: new Text({
                text: unicodeChar,
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: '#000',
                }),
              }),
            });
        }
      }
  
      // Get the feature's state
      const featureState = feature.get('state');
      ////logger.log("Feature State:", featureState);
  
      // Find the corresponding state in the states array
      const correspondingState = states.find(state => state.id === featureState);
      ////logger.log("Corresponding State:", correspondingState);
  
      // Check if the state is "Default" (assuming 'Default' is identified by state title)
      if (correspondingState && correspondingState.title === 'Default') {
        ////logger.log("Using default style for feature:", feature);
        // Use the current default style behavior
        const geometryType = feature.getGeometry().getType();
  
        switch (geometryType) {
          case 'Point':
          case 'MultiPoint':
            return new Style({
              image: new Circle({
                radius: 13,
                fill: new Fill({
                  color: fillColor,
                }),
                stroke: new Stroke({
                  color: patternColor,
                  width: 2,
                  lineDash: lineDash,
                }),
              }),
              text: new Text({
                text: unicodeChar,
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: patternColor,
                }),
              }),
            });
  
          case 'LineString':
          case 'MultiLineString':
            return new Style({
              stroke: new Stroke({
                color: patternColor,
                width: 4,
                lineDash: lineDash,
              }),
            });
  
          case 'Polygon':
          case 'MultiPolygon':
            return new Style({
              fill: new FillPattern({
                pattern: pattern,
                color: patternColor,
                fill: new Fill({
                  color: fillColor,
                }),
                size: 10,
                width: 1,
              }),
              stroke: new Stroke({
                color: patternColor,
                width: 2,
                lineDash: lineDash,
              }),
              text: new Text({
                text: unicodeChar,
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: patternColor,
                }),
              }),
            });
  
          default:
            return new Style({
              fill: new Fill({
                color: fillColor,
              }),
              stroke: new Stroke({
                color: patternColor,
                width: 2,
              }),
              text: new Text({
                text: unicodeChar,
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: '#000',
                }),
              }),
            });
        }
      } else {
        ////logger.log("Applying custom style for non-default state");
        const newUnicodeChar = getFaUnicode(correspondingState?.icon) || unicodeChar;
        const geometryType = feature.getGeometry().getType();

        switch (geometryType) {
          case 'Point':
          case 'MultiPoint':
            // Non-default state logic
            return new Style({
              image: new Circle({
                radius: 13,
                fill: new Fill({
                  color: correspondingState?.background || fillColor, // Use state's background or default red
                }),
                stroke: new Stroke({
                  color: correspondingState?.color || patternColor, // Use state's color or default black
                  width: 2,
                  lineDash: lineDash,
                }),
              }),
              text: new Text({
                text: unicodeChar, //newUnicodeChar, // Use the Unicode character from the state's icon
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: correspondingState?.color || patternColor, // Use state's color or default pattern color
                }),
              }),
            });
    
          case 'LineString':
          case 'MultiLineString':
            return new Style({
              stroke: new Stroke({
                color: correspondingState?.color || patternColor, // Use state's color or default
                width: 4,
                lineDash: lineDash,
              }),
            });
    
          case 'Polygon':
          case 'MultiPolygon':
            return new Style({
              fill: new FillPattern({
                pattern: pattern,
                color: correspondingState?.color || patternColor, // Use state's color or default
                fill: new Fill({
                  color: correspondingState?.background || fillColor, // Use state's background or default fill color
                }),
                size: 10,
                width: 1,
              }),
              stroke: new Stroke({
                color: correspondingState?.color || patternColor, // Use state's color or default pattern color
                width: 2,
                lineDash: lineDash,
              }),
              text: new Text({
                text: unicodeChar, //newUnicodeChar, // Use the Unicode character from the state's icon
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: correspondingState?.color || patternColor, // Use state's color or default
                }),
              }),
            });
    
          default:
            return new Style({
              fill: new Fill({
                color: correspondingState?.background || fillColor, // Use state's background or default fill color
              }),
              stroke: new Stroke({
                color: correspondingState?.color || patternColor, // Use state's color or default pattern color
                width: 2,
              }),
              text: new Text({
                text: unicodeChar, //newUnicodeChar, // Use the Unicode character from the state's icon
                scale: 1,
                font: '900 15px "Font Awesome 5 Free"',
                textAlign: 'center',
                fill: new Fill({
                  color: '#000',
                }),
              }),
            });
          }
        };
      };
    };

  // Create a vector layer from a source
  const layerStates = {};

  const createLayerFromSource = (source, layer, states) => {
    if (source.title.startsWith('GPS') || source.title.startsWith('IPS')) {
      const vectorSource = new VectorSource();

      const layerStyle = createStyleFromLayer(layer, states);
      ////logger.log("Layer style: ", layerStyle);

      // Use layer.id as the unique key instead of title
      const prevState = layerStates[layer.id] || {};

      let vectorLayer;
      if (layer.title.startsWith('GPS')) {
        vectorLayer = new VectorLayer({
          source: vectorSource,
          style: layerStyle, // Apply the red point style
          title: `<div style="color:${layer.background}"><i class="${layer.icon}"></i> ${layer.title}</div>`,
          visible:layer.is_enabled, // Ensure the layer is visible
          opacity: parseFloat(layer.opacity) || 1,
          zIndex: layer.title === 'GPS - Greek Pilot Area' ? 9000 : 9999, // Set zIndex to 9999
        });
        vectorLayer.set('name', layer.title);
        vectorLayer.set('id', layer.id);

        setLayersState((prevLayers) => [...prevLayers, vectorLayer]);
      } else if (layer.title.startsWith('IPS')) {
        vectorLayer = new VectorLayer({
          source: vectorSource,
          style: layerStyle, // Apply the red point style
          title: `<div style="color:${layer.background}"><i class="${layer.icon}"></i> ${layer.title}</div>`,
          visible: layer.is_enabled, // Ensure the layer is visible
          opacity: parseFloat(layer.opacity) || 1,
          zIndex: layer.title === 'IPS - Italian Pilot Area' ? 9000 : 9999, // Set zIndex to 9999
        });
        vectorLayer.set('name', layer.title);
        vectorLayer.set('id', layer.id);

        setLayersState((prevLayers) => [...prevLayers, vectorLayer]);
      }
      else {
        vectorLayer = null;
      }

      ////logger.log(`VectorLayer created for source: ${source.title} with zIndex 9999`);

      return { layer: vectorLayer, vectorSource };
    }
    return null;
  };

  // Add features to a vector source
  const addFeaturesToSource = (features, vectorSource, source, projections, selectedDate) => {
    features.forEach(feature => {
      if (feature.sources.includes(source.id)) { // Check if the feature belongs to this source
        
        const validFrom = feature.valid_from ? new Date(feature.valid_from).toISOString().split('T')[0] : new Date('1900-01-01').toISOString().split('T')[0];
      
        // Default valid_to to 31-12-3000 if null
        const validTo = feature.valid_to ? new Date(feature.valid_to).toISOString().split('T')[0] : new Date('3000-12-31').toISOString().split('T')[0];
        if (feature.title === "Black Box - 01") {
          //logger.log("valid from: ", validFrom);
          //logger.log("valid to: ", validTo);
          //logger.log("selected date: ", selectedDate);  
        }


        // Check if the selected date is between valid_from and valid_to
        if (selectedDate >= validFrom && selectedDate <= validTo) {
          ////logger.log(`Adding feature ${feature.title} to source: ${source.title}`);
  
          const olFeature = new GeoJSON().readFeature(feature.geometry, {
            dataProjection: 'EPSG:4326', // Feature data is in lon/lat (EPSG:4326)
            featureProjection: 'EPSG:3857', // Transform to EPSG:3857 for display on map
          });
  
          // Set properties to the feature
          olFeature.setProperties({
            id: feature.id,
            title: feature.title,
            description: feature.description,
            contact: feature.contact,
            image: feature.image,
            sources: feature.sources,
            address: feature.address,
            valid_from: feature.valid_from,
            valid_to: feature.valid_to,
            state: feature.state,
          });
  
          // Add the feature to the vector source
          vectorSource.addFeature(olFeature);
  
          // Log the current features in the vector source
          // //logger.log("Features in VectorSource after adding:", vectorSource.getFeatures());
        }
      }
    });
  };

  // Set up the map and add layers to the map after data is fetched
  useEffect(() => {

    setLoading(true);
    
    // Load saved BBOX from localStorage if available
    const savedBbox = localStorage.getItem('mapBbox');

    // Initialize the map only once
    if (!mapRef.current) {
      const map = new Map({
        target: "map",
        controls: defaultControls({ zoom: false }).extend([
          new ScaleLine({
            units: 'metric',
            bar: true,
            steps: 4,
            text: true,
            minWidth: 140,
            maxWidth: 140,
          }),
          new MousePosition({
            coordinateFormat: createStringXY(4), // Formats the coordinates to 4 decimal places
            projection: 'EPSG:4326', // Set projection to WGS84 (latitude/longitude)
            className: 'mouse-position', // Class name for styling
            target: document.getElementById('mouse-position'), // The DOM element to display the mouse position
            undefinedHTML: '&nbsp;', // What to display when the mouse is outside the map
          })
        ]),
        layers: [
          new TileLayer({
            source: new OSM({ attributions: [] }),
            title: "Map",
            displayInLayerSwitcher: false,
            displayInLayerSwitcherImage: true,
          }),
        ],
        view: new View({
          center: fromLonLat([location.longitude, location.latitude]),
          zoom: 5,
        }),
      });
      mapRef.current = map;

      // If a BBOX is saved, fit the map view to this BBOX
      if (savedBbox) {
        const bbox = JSON.parse(savedBbox);
        const extent = bbox.map(coord => parseFloat(coord)); // Parse the bbox array
        map.getView().fit(extent, { size: map.getSize() });
      };

      // Save the current BBOX to localStorage whenever the map is moved or zoomed
      map.on('moveend', () => {
        const extent = map.getView().calculateExtent(map.getSize());
        localStorage.setItem('mapBbox', JSON.stringify(extent));
      });

      // Fetch and combine sources with categories (e.g., from API)
      combineSourcesWithCategories()
      .then(combinedSources => {
        // Assign tile layers to LayerSwitcherImage
        assignTileLayerToLayerSwitcherImage(combinedSources, map);

        // Create the LayerSwitcherImage control
        const layerSwitcherImage = new LayerSwitcherImage({        
          reordering: false,
          mouseover: false,
          collapsed: true,
          toggleOne: true,
          displayInLayerSwitcher: (layer) => layer instanceof TileLayer,
        });

        // Function to set a default image for the main button
        const setDefaultMainButtonImage = () => {
          const mainButton = document.querySelector('.ol-layerswitcher-image > button');
          if (mainButton) {
            mainButton.style.backgroundImage = 'url(https://tile.openstreetmap.org/10/512/349.png)';
            mainButton.style.backgroundSize = 'cover';
            mainButton.style.backgroundColor = 'transparent';
            mainButton.textContent = '';
            mainButton.title = 'Map'; // Default tooltip
          }
        };

        // Function to update the main button image and tooltip based on the current layer
        const updateMainButtonImage = (layer) => {
          const mainButton = document.querySelector('.ol-layerswitcher-image > button');
          if (!mainButton) return;

          const listItem = Array.from(document.querySelectorAll('.ol-imgcontainer'))
            .find(li => li.querySelector('p').textContent.trim() === layer.get('title'));

          if (listItem) {
            const imgElement = listItem.querySelector('img');
            if (imgElement && imgElement.src) {
              mainButton.style.backgroundImage = `url(${imgElement.src})`;
              mainButton.style.backgroundSize = 'cover';
              mainButton.style.backgroundColor = 'transparent';
              mainButton.textContent = '';
              mainButton.title = layer.get('title').replace(/^TS - /, ''); // Tooltip for main button
              return;
            }
          }

          // If no matching layer or image found, set the default image
          setDefaultMainButtonImage();
        };

        // Add the LayerSwitcher control to the map
        map.addControl(layerSwitcherImage);

        // After the control has been added to the map, modify its className
        layerSwitcherImage.element.className += ' custom-layer-switcher-image';

        // Add event listener to handle layer selection
        document.querySelectorAll('.ol-layerswitcher-image li').forEach(item => {
          item.addEventListener('click', () => {
            // Add the collapsed class to hide the layer switcher
            layerSwitcherImage.element.classList.add('ol-collapsed');
          });
        });

        // Ensure the button is always visible
        const ensureButtonVisible = () => {
          const mainButton = document.querySelector('.ol-layerswitcher-image > button');
          if (mainButton) {
            mainButton.style.display = 'block'; // Force button display
            mainButton.style.opacity = '1';    // Ensure fully visible
            mainButton.style.visibility = 'visible';
          }
        };

        // Ensure button visibility after render
        layerSwitcherImage.once('rendercomplete', ensureButtonVisible);

        // Maintain button visibility when collapsed
        layerSwitcherImage.on('collapse', ensureButtonVisible);

        layerSwitcherImage.on('expand', ensureButtonVisible);

        // Get the initially visible layer (default map layer)
        const initialLayer = map.getLayers().getArray().find(layer => layer.getVisible());
        if (initialLayer) {
          updateMainButtonImage(initialLayer);
        } else {
          setDefaultMainButtonImage();
        }

        // Ensure the button updates correctly after rendercomplete
        layerSwitcherImage.once('rendercomplete', () => {
          // Handle the initially visible layer
          const visibleLayer = map.getLayers().getArray()
            .find(layer => layer?.getVisible && layer.getVisible());
          if (visibleLayer) {
            updateMainButtonImage(visibleLayer);
          } else {
            setDefaultMainButtonImage();
          }
        
          // Iterate over each li element in the layer switcher
          document.querySelectorAll('.ol-layerswitcher-image .panel-container ul > li').forEach(li => {
            // Find the title from <p> within the current li
            const titleElement = li.querySelector('p');
            if (!titleElement) return; // Skip if no <p> tag found
        
            // Clean the title
            const layerTitle = titleElement.textContent.trim().replace(/^TS - /, '') || 'Unnamed Layer';
        
            // Set tooltip for the image
            const imgElement = li.querySelector('img');
            if (imgElement && imgElement.src) {
              imgElement.title = layerTitle; // Tooltip for the image
            }
        
            // Set tooltip for the li element
            li.title = layerTitle; // Tooltip for the list item
          });
        });                

        // Enforce single-layer visibility and update the button image when layers toggle
        let isTogglingLayer = false;

        layerSwitcherImage.on('layer:visible', function (evt) {
          if (isTogglingLayer) return;
          isTogglingLayer = true;

          const selectedLayer = evt.layer;
          map.getLayers().forEach(l => {
            if (l === selectedLayer) {
              l.setVisible(true);
              updateMainButtonImage(l);

              // Add `selected-layer` class to the corresponding list item
              const listItem = Array.from(document.querySelectorAll('.ol-imgcontainer'))
                .find(li => li.querySelector('p').textContent.trim() === l.get('title'));
              if (listItem) {
                listItem.classList.add('selected-layer');
              }
            } else if (l.get('displayInLayerSwitcherImage')) {
              l.setVisible(false);

              // Remove `selected-layer` class from non-selected layers
              const listItem = Array.from(document.querySelectorAll('.ol-imgcontainer'))
                .find(li => li.querySelector('p').textContent.trim() === l.get('title'));
              if (listItem) {
                listItem.classList.remove('selected-layer');
              }
            }
          });

          isTogglingLayer = false;

          layerSwitcherImage.render();

          // Collapse the Layer Switcher Image after selection
          document.querySelector('.ol-layerswitcher-image').classList.add('collapsed');
        });
      })
      .catch(error => {
        //logger.error("Error during the assignment process:", error);
      });

    };

    // Fetch data once
    fetchAllData();

    const excludedLayerNames = ['GPS - Greek Pilot Area', 'IPS - Italian Pilot Area'];

    selectToViewRef.current = new Select({
      layers: (layer) => !excludedLayerNames.includes(layer.get('name'))
    });
    mapRef.current.addInteraction( selectToViewRef.current);

    selectToViewRef.current.on('select', handleSelectToView);

    const dateSelectionButton = new Button({
      html: '<i class="fas fa-calendar-alt"></i>',
      title: 'Date Picker',
      className: "section",
      active: false,
      handleClick: function () {
        const dialogContent = `
          <div>
            <label for="selected-date">Select Date:</label>
            <input type="date" id="selected-date" value="${selectedDate}">
            <br/><br/>
            <div style="cursor: pointer; display: inline-block; padding: 5px 10px; border: 1px solid; border-radius: 5px;" id="saveButton">
              <i class="fas fa-check"></i>Confirm
            </div>
          </div>
        `;
    
        const dialog = new Dialog({
          content: dialogContent,
          closeBox: true,
          onclose: function() {
            dialog.destroy();
            setShowDialog(false); // Ensure dialog is hidden
            setHoverLock(false);  // Unlock hover info
          }
        });
    
        mapRef.current.addControl(dialog);
        setShowDialog(true);
        setHoverLock(true);
        dialog.show();
    
        // Attach the event listener directly to the dialog or save button
        const dialogElement = dialog.getContentElement();
    
        dialogElement.querySelector('#saveButton').addEventListener('click', function () {
          handleSaveButtonClick(dialog); // Handle date save
          dialog.hide(); // Close the dialog after saving
          setHoverLock(false); // Unlock hover info after dialog is closed
          setShowDialog(false);
        
        });
      },
    });
  
    // Handle hover logic with hoverLock
    dateSelectionButton.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current) {
        updateHoverButtonInfo('<i class="fas fa-calendar-alt"></i> <strong>Date Picker</strong>: Click to open the date selection dialog, allowing you to choose a specific date for retrieving or viewing historical map data.');
      }
    });
    dateSelectionButton.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const handleSaveButtonClick = (dialog) => {
      const inputElement = document.getElementById('selected-date');
      if (inputElement) {
        const inputDate = inputElement.value;
        //logger.log("input date: ", inputDate);
        if (inputDate) {
          let newDate = new Date(inputDate).toISOString().split('T')[0];
          //logger.log("new date: ", newDate);
          setSelectedDate(newDate);
          // logger.log("selected date: ", selectedDate);
        }
        inputElement.remove();
        dialog.close();
        setHoverLock(false);
        setShowDialog(false);
      }
    };

    // Add this button to the controls array in baseControlBar
    const controls = [
        dateSelectionButton,
    ];
    
    const baseControlBar = new ControlBar({
        controls: controls,
        orientation: "horizontal",
        className: "base-control-bar",
    });

    baseControlBar.setPosition("top-center");
    mapRef.current.addControl(baseControlBar);

    if (!layerSwitcherRef.current){
      layerSwitcherRef.current = new LayerSwitcher({
        mouseover: false,
        reordering: true,
      });

      mapRef.current.addControl(layerSwitcherRef.current);
    }

    mapRef.current.getLayers().forEach((layer) => {
      console.log(`Attaching listener to layer ${layer.getProperties().id}`);
      layer.on("change:visible", () => {
        const layerId = layer.getProperties().id; // Get the layer's ID
        const isEnabled = layer.getVisible(); // Get the new visibility state
        console.log(`Layer ${layer.getProperties().id} visibility changed to: ${layer.getVisible()}`);
        console.log(`Layer ${layerId} visibility changed: ${isEnabled}`);
    
        updateLayers(layerId, { is_enabled: isEnabled }); // Update DB only for this layer
      });
    });
    

    setLoading(false);
    
  }, [selectedDate]);

  useEffect(() => {
    if (!layersState.length) return; // Ensure layers exist
  
    logger.log("Attaching visibility listeners to layers...");

    // logger.log("Layers found:", layersState.getLength());
    // layersState.forEach((layer) => {
    //   logger.log("Layer ID:", layer.getProperties().id);
    //   logger.log("Layer properties:", layer.getProperties());
    //   logger.log("Layer type:", layer instanceof TileLayer? "Tile Layer" : "Other Layer");
    // });
  
    layersState.forEach((layer) => {
      if (!layer.get("hasListeners")) {
        logger.log(`Attaching listener to layer ${layer.getProperties().id}`);

        layer.on("change:visible", () => {
          const layerId = layer.getProperties().id; // Get the layer's ID
          const isEnabled = layer.getVisible(); // Get the new visibility state
          logger.log(`Layer ${layer.getProperties().id} visibility changed to: ${layer.getVisible()}`);
          logger.log(`Layer ${layerId} visibility changed: ${isEnabled}`);
      
          updateLayers(layerId, { is_enabled: isEnabled }); // Update DB only for this layer
        });

        let lastOpacityValue = null; // Store the last opacity value

        layer.on("change:opacity", () => {
          lastOpacityValue = parseFloat(layer.getOpacity().toFixed(2)); // Always update the last known opacity
          logger.log(`Layer ${layer.getProperties().id} opacity changing: ${lastOpacityValue}`);
        });
        
        // ✅ Call API only on `pointerup`
        const handleOpacityUpdate = () => {
          if (lastOpacityValue !== null) {
            const layerId = layer.getProperties().id;
            logger.log(`Updating Layer ${layerId} final opacity: ${lastOpacityValue}`);
            
            // Make a single API call with the last opacity value
            updateLayers(layerId, { opacity: lastOpacityValue });
        
            // Reset the last value
            lastOpacityValue = null;
          }
        
          // Remove listener after executing the update
          window.removeEventListener("pointerup", handleOpacityUpdate);
        };
        
        // ✅ Attach listener **once** per interaction
        window.addEventListener("pointerup", handleOpacityUpdate, { once: true });

        layer.set("hasListeners", true);
      }
    });
  
  }, [layersState]);

  useEffect(() => {
    logger.log("Updated selected date:", selectedDate);
    selectedDateRef.current = selectedDate;
  }, [selectedDate]);

  // let popupElement;
  // let popupOverlay;
  
  // if (!popupElement && !popupOverlay) {
  //   popupElement = document.createElement('div');
  //   popupElement.className = 'feature-popup';  // Class for styling
  //   popupOverlay = new Overlay({
  //     element: popupElement,
  //     positioning: 'bottom-center',  // Keep this to maintain correct functionality
  //     stopEvent: false,
  //   });
  
  //   // Add the popup overlay to the map
  //   mapRef.current.addOverlay(popupOverlay);
  // }

  let functionCallCount = 0;
  let hasRun = false;
  let storedInteractions = [];
  
  const handleSelectToView = async (event) => {
    
    if (hasRun) {
      // mapRef.current.removeInteraction(selectToViewRef.current);
      return;
    }
    hasRun = true;
    functionCallCount++;
    console.log(`handleSelectToView was called ${functionCallCount} times`);

    storedInteractions = mapRef.current.getInteractions().getArray().slice();
    mapRef.current.getInteractions().clear();


    if (selectToViewRef.current) {
      selectToViewRef.current.getFeatures().clear(); // Clear previously selected features
    }
    let properties = null;
    event.target.getFeatures().clear();
    
    const selectedFeature = event.selected[0];
    ////logger.log("Selected Feature: ", selectedFeature)
  
    if (selectedFeature) {
      properties = selectedFeature.values_;
      ////logger.log("Properties of selected feature: ", properties);

      const infoElement = document.getElementById('info-element');
      if (infoElement) {
          infoElement.style.display = 'none'; // Set the element to be hidden
      }

      const existingSidebar = document.getElementById('sidebar');
      if (existingSidebar) {
        existingSidebar.remove(); // Completely remove the sidebar from the DOM
        logger.log("🗑️ Removed existing sidebar");
      }

      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    
      const style = document.createElement('style');
      style.innerHTML = `
        .sidebar {
          width: ${isMobile ? '100%' : '900px'};
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          background-color: white;
          box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
          padding: 0px 20px 20px 20px;
          overflow-y: scroll;
          z-index: 1000;
        }
        .hidden {
          display: none;
        }
        #sidebar-content canvas {
          margin-bottom: 20px;
        }
      `;
      document.head.appendChild(style);
  
      // Check if the sidebar already exists, if not create it
      let sidebar = document.getElementById('sidebar');
      if (!sidebar) {
        // Create the sidebar HTML dynamically
        sidebar = document.createElement('div');
        sidebar.id = 'sidebar';
        sidebar.className = 'sidebar hidden';  // Initially hidden
        sidebar.innerHTML = '';
        
        const stickyContainer = document.createElement('div');
        stickyContainer.style.position = 'sticky';
        stickyContainer.style.top = '0';
        stickyContainer.style.background = 'white'; // Ensure visibility
        stickyContainer.style.padding = '10px';
        stickyContainer.style.zIndex = '1000'; // Keep it above other elements
        stickyContainer.style.borderBottom = '1px solid #ccc'; // Optional: Adds a separator
        
        // Create close button
        const closeButton = document.createElement('button');
        closeButton.id = 'close-sidebar';
        closeButton.innerText = 'Close';
        
        // Append button to sticky container
        stickyContainer.appendChild(closeButton);
        
        // Append sticky container to sidebar
        sidebar.appendChild(stickyContainer);

        const sidebarDate = document.createElement('p');
        sidebarDate.id = 'sidebar-date';
        sidebarDate.innerHTML = `<b>Date:</b> ${selectedDateRef.current}`
        sidebar.appendChild(sidebarDate);
    
        // Create sidebar title
        const sidebarTitle = document.createElement('h3');
        sidebarTitle.id = 'sidebar-title';
        sidebarTitle.innerText = 'Sensor Data';
        sidebar.appendChild(sidebarTitle);
  
        const descriptionElement = document.createElement('p');
        descriptionElement.id = 'sidebar-description';
        // descriptionElement.innerText = properties.description || 'No Description Available';
        descriptionElement.style.marginTop = '10px';  
        descriptionElement.style.fontSize = '14px';  
        sidebar.appendChild(descriptionElement);

  
        const addressElement = document.createElement('small');
        addressElement.id = 'sidebar-address';
        // addressElement.innerHTML = `<strong>Address:</strong> ${properties.address || 'No Address Available'}`;
        addressElement.style.marginTop = '10px';  
        addressElement.style.fontSize = '14px';  
        sidebar.appendChild(addressElement);

        const windDirectionElement = document.createElement('div');
        windDirectionElement.id = 'wind-direction';  // Assign the id
        windDirectionElement.style.marginTop = '20px';  // Optional styling
        sidebar.appendChild(windDirectionElement);  // Append it to the sidebar

        const miniMapContainer = document.createElement('div');
        miniMapContainer.id = 'mini-map';
        miniMapContainer.style.width = '0px';
        miniMapContainer.style.height = '0px';  // Adjust as necessary for the mini map size
        miniMapContainer.style.marginTop = '20px';  // Optional styling
        sidebar.appendChild(miniMapContainer);

        if (properties.image) {
          const img = new Image();
          
          img.onload = function () {
            const imgElement = document.createElement('img');
            imgElement.id = 'sidebar-image';
            imgElement.src = properties.image; // ✅ Assign only if valid
            imgElement.alt = `Image for ${properties.title || 'No Title'}`;
            imgElement.style.width = '100%';
            imgElement.style.maxHeight = '300px';
            imgElement.style.marginTop = '30px';
        
            sidebar.appendChild(imgElement); // ✅ Append only if valid
          };
        
          img.onerror = function () {
            logger.warn("⚠️ Invalid image URL:", properties.image);
          };
        
          img.src = properties.image; // Start loading
        }
        

        // Check for Municipal Command Center - Massa Lubrense
        // if (properties.title.includes('Municipal Command Center')) {
        //   // Scope button for sending coordinates with Font Awesome icon
        //   const scopeButton = document.createElement('button');
        //   scopeButton.innerHTML = '<i class="fas fa-crosshairs"></i> Send Coordinates';  // Initial icon for targeting
        //   scopeButton.title = 'Send Coordinates';
        //   scopeButton.style.margin = '10px';
        //   scopeButton.onclick = () => {
        //     const geometry = selectedFeature.getGeometry();
        //     const [longitude, latitude] = geometry.getCoordinates();
        
        //     sendCoordinates({ longitude, latitude })
        //       .then(() => {
        //         scopeButton.innerHTML = '<i class="fas fa-check" style="color: green;"></i> Success';  // Success tick icon
        //         scopeButton.title = 'Coordinates Sent Successfully';
        //       })
        //       .catch((error) => {
        //         scopeButton.innerHTML = '<i class="fas fa-times" style="color: red;"></i> Try Again';  // Error icon with message
        //         scopeButton.title = 'Failed to Send Coordinates';
        //         ////logger.error("Failed to send coordinates:", error);
        //       });
        //   };
        //   sidebar.appendChild(scopeButton);
        // }
  
        const sidebarContent = document.createElement('div');
        sidebarContent.id = 'sidebar-content';
        sidebar.appendChild(sidebarContent);
    
        document.body.appendChild(sidebar);
  
        closeButton.addEventListener('click', () => {
          
          sidebar.classList.add('hidden');
          miniMapContainer.remove();
          sidebar.remove();  // Remove the entire sidebar element
          storedInteractions.forEach(interaction => mapRef.current.addInteraction(interaction));
          hasRun = false;                     
          if (infoElement) {
            infoElement.style.display = 'block';
          }
        });
      }
  
      ////logger.log("Selected Feature Properties: ", properties);
  
      // Clear previous content from the sidebar
      const sidebarContent = document.getElementById('sidebar-content');
      sidebarContent.innerHTML = '';
  

      const map = mapRef.current;  // Assuming you have the map reference stored

      // Get the coordinates of the selected feature
      const geometry = selectedFeature.getGeometry();
      const coordinates = geometry.getCoordinates();

      // Create a div for the loader
      const loaderElement = document.createElement('div');
      loaderElement.className = 'loader'; // Use the loader CSS from earlier

      // Create the overlay for the loader
      const loaderOverlay = new Overlay({
          element: loaderElement,
          positioning: 'center-center',  // Position the loader at the feature point
          stopEvent: false,  // Prevent mouse events on the overlay
      });

      // Set the position of the overlay to the feature's coordinates
      loaderOverlay.setPosition(coordinates);
      map.addOverlay(loaderOverlay);  // Add the overlay to the map

      // Check if the selected feature is "Ignition Point - 01 - Samaria"
      // if (properties.title === "Ignition Point - 01 - Samaria" || properties.title.includes("Object Detection")) {
      //   // Handle special case for Ignition Point
      //   ////logger.log("Displaying details for Ignition Point - 01 - Samaria");

      //   const geometry = selectedFeature.getGeometry();
      //   const [longitude, latitude] = geometry.getCoordinates();
      //   const [lon, lat] = transform([longitude, latitude], 'EPSG:3857', 'EPSG:4326');

      //   // Update sidebar content for the Ignition Point
      //   const descriptionElement = document.getElementById('sidebar-description');
      //   const imgElement = document.getElementById('sidebar-image');
      //   const sidebarTitle = document.getElementById('sidebar-title');

      //   sidebarTitle.innerHTML = properties.title || 'No Title';
      //   descriptionElement.innerHTML = properties.description || 'No Description Available';
      //   if (imgElement) {
      //     imgElement.src = properties.image || ''; // Set the image URL from properties.image
      //     imgElement.alt = `Image for ${properties.title || 'No Title'}`;
      //   }

      //   sidebarContent.innerHTML += `
      //     <p><strong>Coordinates:</strong> Latitude: ${lat}, Longitude: ${lon}</p>
      //   `;

      //  // Create a unique mini-map container
      //  let miniMapContainer = document.getElementById('mini-map');

      //  miniMapContainer.style.width = '100%';
      //  miniMapContainer.style.height = '300px';  // Adjust size as necessary
       
      //  let existingMiniMap = miniMapContainer._miniMapInstance;
       
      //  if (!existingMiniMap) {
      //    // Create the OpenLayers mini-map only if it doesn't exist
      //    const miniMap = new Map({
      //      target: miniMapContainer,  // Use the pre-existing container
      //      layers: [
      //        new TileLayer({
      //          source: new OSM(),  // Use OpenStreetMap as the base layer
      //        })
      //      ],
      //      view: new View({
      //        center:  fromLonLat([lon, lat]),  // Center on the last longitude and latitude
      //        zoom: 13,  // Adjust zoom level as necessary
      //      })
      //    });

      //      // Create a vector layer to hold the dots (features)
      //       const vectorSource = new VectorSource();

      //       // Add a point feature for each lat/lon pair
      //       const pointFeature = new Feature({
      //         geometry: new Point(fromLonLat([lon, lat])),
      //       });
      //         // Assign a style with a number displayed
      //         pointFeature.setStyle(
      //           new Style({
      //             image: new Circle({
      //               radius: 10, // Adjust size to accommodate text
      //               fill: new Fill({ color: '#ff0000' }), // Red color for the dots
      //               stroke: new Stroke({
      //                 color: '#ffffff', // White border for the dots
      //                 width: 2,
      //               }),
      //             }),
      //           })
      //         );
          
      //         vectorSource.addFeature(pointFeature);

      //       // Add the vector layer with the dots to the map
      //       const vectorLayer = new VectorLayer({
      //           source: vectorSource,
      //       });
      //       miniMap.addLayer(vectorLayer);
       
      //    // Save a reference to the mini-map instance for reuse
      //    miniMapContainer._miniMapInstance = miniMap;
       
      //    miniMap.once('rendercomplete', () => {
      //      miniMap.updateSize();  // Ensure map size is updated after rendering
      //      ////logger.log(`Mini-map created and centered at Latitude: ${latitude}, Longitude: ${longitude}`);
      //    });

      //  } else {
      //    // If the map already exists, just update the view center
      //    const miniMapView = existingMiniMap.getView();
      //    miniMapView.setCenter(fromLonLat([lon, lat]));
      //    miniMapView.setZoom(15);  // Adjust zoom level if necessary
       
      //    ////logger.log(`Mini-map updated and centered at Latitude: ${latitude}, Longitude: ${longitude}`);
      //  }

      //   // Make sure the sidebar is visible
      //   map.removeOverlay(loaderOverlay);
      //   sidebar.classList.remove('hidden');
      //   return; // Exit here since we've handled the specific case
      // }
  
      if (properties.title !== "Greek Pilot Area - Samaria Gorge Bounding Box" && properties.title !== "Italian Pilot Area - Sorrento, Italy Bounding Box") {

          try {
            const sensors = await fetchSensorsById(properties.id);
        
            const sidebarContent = document.getElementById('sidebar-content');
            sidebarContent.innerHTML = `<b><span style="white-space: nowrap;">Last Values At: </span></b>`;  // This will only appear once
            
            let isFirstLoop = true;
            // Loop through each sensor and append its last value under the "Last Values" heading
            for (const sensor of sensors) {
              const sensorData = await fetchSensorData(sensor.id);
            
              // Get the last value from the sensorData
              if (sensorData.length > 0) {
                const lastData = sensorData[sensorData.length - 1]; // Get the last data point

                if (isFirstLoop) {
                  isFirstLoop = false; // Mark that the first loop has passed
              
                  const dateObj = new Date(lastData.timestamp);
                  const formattedDate = dateObj.toISOString() //.split('T')[0]; // ✅ Extracts YYYY-MM-DD
            
                  const sidebarContent = document.getElementById('sidebar-content');
                  if (sidebarContent) {
                    // ✅ Use inline styling to prevent line break
                    sidebarContent.innerHTML += `<span style="white-space: nowrap;">${formattedDate}</span>`;
                  }
                }

                logger.log("Last Sensor Data: ", lastData);
                // Create a unique ID for each sensor's last value entry
                const sensorValueId = `last-value-${sensor.id}`;
            
                // Check if an element for this sensor's last value already exists and remove it if needed
                let sensorValueElement = document.getElementById(sensorValueId);
                if (sensorValueElement) {
                  sensorValueElement.remove();  // Remove the existing element to prevent duplicates
                }
            
                // Create a new element for this sensor's last value
                sensorValueElement = document.createElement('p');
                sensorValueElement.id = sensorValueId;  // Assign the unique ID
                sensorValueElement.innerHTML = `<strong>${sensor.title}:</strong> ${lastData.value}`;
            
                // Append the sensor's last value directly to the sidebar content
                const sidebarContent = document.getElementById('sidebar-content');
                sidebarContent.appendChild(sensorValueElement);
              } else {
                ////logger.log(`No data available for ${sensor.title}`);
              }
            }

          } catch (error) {
            ////logger.error("Error fetching sensors:", error);
            // Get the geometry and transform coordinates to EPSG:4326
            // const geometry = selectedFeature.getGeometry();
            // const [longitude, latitude] = geometry.getCoordinates();
            // const [lon, lat] = transform([longitude, latitude], 'EPSG:3857', 'EPSG:4326');
          
            // // Update the sidebar content using the selected feature properties
            // const descriptionElement = document.getElementById('sidebar-description');
            // const imgElement = document.getElementById('sidebar-image');
            // const sidebarTitle = document.getElementById('sidebar-title');
          
            // sidebarTitle.innerHTML = properties.title || 'No Title';
            // descriptionElement.innerHTML = properties.description || 'No Description Available';
            
            // if (imgElement) {
            //   imgElement.src = properties.image || ''; // Set the image URL from properties.image
            //   imgElement.alt = `Image for ${properties.title || 'No Title'}`;
            // }
          
            // // Display the coordinates (latitude and longitude)
            // sidebarContent.innerHTML += `
            //   <p><strong>Coordinates:</strong> Latitude: ${lat}, Longitude: ${lon}</p><br/><br/>
            //   <h4>No Sensor Data Available</h4>
            // `;
          
            // sidebar.classList.remove('hidden');  // Ensure the sidebar is visible
          }

        try {
          const sensors = await fetchSensorsById(properties.id);
          const sidebarTitle = document.getElementById('sidebar-title');
          const descriptionElement = document.getElementById('sidebar-description');
          const addressElement = document.getElementById('sidebar-address');
          const imgElement = document.getElementById('sidebar-image');

          sidebarTitle.innerHTML = `Data for ${properties.title || 'No Title'}`;
          descriptionElement.innerHTML = `${properties.description || 'No Description Available'}`;
          addressElement.innerHTML = `<strong>Address:</strong> ${properties.address || 'No Address Available'}`;
          
          if (imgElement) {
            if (properties.image) {
              imgElement.src = properties.image; 
              imgElement.alt = `Image for ${properties.title || 'No Title'}`;
            } else {
              imgElement.src = '';  // Clear the src if no image is available
              imgElement.alt = 'No Image Available';
              imgElement.style.display = 'none';  // Hide the image if none exists
            }
          }

          let latitude = null;
          let longitude = null;

          let latitudes = [];
          let longitudes = [];

          // Loop through each sensor and fetch its data
          for (const sensor of sensors) {
            const sensorData = await fetchSensorData(sensor.id);
            logger.log("Sensor: ", sensor);
            // console.log("All Sensor Data for sensor ", sensor,": ", sensorData);
            ////logger.log(`Data for sensor ${sensor.id}:`, sensorData);

            if (sensor.title.toLowerCase().includes('wind direction')) {
              // Populate the wind direction element with the last wind direction value
              const lastData = sensorData[sensorData.length - 1]; // Get the last data point
              let direction = lastData.value.trim().toUpperCase();  // Ensure it's uppercase for consistency
  
              // Convert abbreviated directions to full names using a switch statement
              switch (direction) {
                case 'N':
                  direction = 'North';
                  break;
                case 'S':
                  direction = 'South';
                  break;
                case 'E':
                  direction = 'East';
                  break;
                case 'W':
                  direction = 'West';
                  break;
                case 'NE':
                  direction = 'Northeast';
                  break;
                case 'NW':
                  direction = 'Northwest';
                  break;
                case 'SE':
                  direction = 'Southeast';
                  break;
                case 'SW':
                  direction = 'Southwest';
                  break;
                default:
                  direction = `Unknown (${lastData.value})`;  // Handle unexpected values
                  break;
              }
              const windDirectionElement = document.getElementById('wind-direction');
              windDirectionElement.innerHTML = `<strong>Wind Direction:</strong> ${direction}`;
              continue;
            } else if (
                sensor.title.toLowerCase().includes('latitude') ||
                sensor.title.toLowerCase().includes('longitude')
              ) {
                logger.log(`Initializing mini map for sensor: ${sensor.title}`);
                if (sensor.title.toLowerCase().includes('latitude')) {
                  const lastData = sensorData[sensorData.length - 1]; // Get the last data point
                  latitude = parseFloat(lastData.value);  // Store the last latitude value
                  latitudes = sensorData.map(data => ({ value: parseFloat(data.value), timestamp: data.timestamp }));
                  ////logger.log(`Latitude for ${sensor.title}: ${latitude}`);
                } 
                else if (sensor.title.toLowerCase().includes('longitude')) {
                  const lastData = sensorData[sensorData.length - 1]; // Get the last data point
                  longitude = parseFloat(lastData.value);  // Store the last longitude value
                  longitudes = sensorData.map(data => ({ value: parseFloat(data.value), timestamp: data.timestamp }));
                  ////logger.log(`Longitude for ${sensor.title}: ${longitude}`);
                }

                let latLonPairs = [];
                latitudes.forEach(lat => {
                    const matchingLon = longitudes.find(lon => lon.timestamp === lat.timestamp);
                    if (matchingLon) {
                        latLonPairs.push({
                            latitude: lat.value,
                            longitude: matchingLon.value
                        });
                    }
                });

                // Only initialize or update the map when both latitude and longitude are available
                if (latLonPairs.length > 0) {
                  ////logger.log(`Initializing mini map with Latitude: ${latitude}, Longitude: ${longitude}`);

                  // Create a unique mini-map container
                  let miniMapContainer = document.getElementById('mini-map');

                  miniMapContainer.style.width = '100%';
                  miniMapContainer.style.height = '300px';  // Adjust size as necessary
                  
                  let existingMiniMap = miniMapContainer._miniMapInstance;
                  
                  if (!existingMiniMap) {
                    // Create the OpenLayers mini-map only if it doesn't exist
                    const miniMap = new Map({
                      target: miniMapContainer,  // Use the pre-existing container
                      layers: [
                        new TileLayer({
                          source: new OSM(),  // Use OpenStreetMap as the base layer
                        })
                      ],
                      view: new View({
                        center:  fromLonLat([latLonPairs[0].longitude, latLonPairs[0].latitude]),  // Center on the last longitude and latitude
                        zoom: 13,  // Adjust zoom level as necessary
                      })
                    });

                      // Create a vector layer to hold the dots (features)
                const vectorSource = new VectorSource();

                // Add a point feature for each lat/lon pair
                latLonPairs.forEach((pair, index) => {
                  const pointFeature = new Feature({
                    geometry: new Point(fromLonLat([pair.longitude, pair.latitude])),
                  });
              
                  // Assign a style with a number displayed
                  pointFeature.setStyle(
                    new Style({
                      image: new Circle({
                        radius: 10, // Adjust size to accommodate text
                        fill: new Fill({ color: '#ff0000' }), // Red color for the dots
                        stroke: new Stroke({
                          color: '#ffffff', // White border for the dots
                          width: 2,
                        }),
                      }),
                      text: new Text({
                        text: String(index + 1), // Auto-incremented number
                        font: '12px Arial', // Font size and family
                        fill: new Fill({ color: '#ffffff' }), // White text
                        stroke: new Stroke({ color: '#000000', width: 2 }), // Black border for contrast
                        textAlign: 'center',
                        textBaseline: 'middle',
                      }),
                    })
                  );
              
                  vectorSource.addFeature(pointFeature);
                });

                // Add the vector layer with the dots to the map
                const vectorLayer = new VectorLayer({
                    source: vectorSource,
                });
                miniMap.addLayer(vectorLayer);
                  
                    // Save a reference to the mini-map instance for reuse
                    miniMapContainer._miniMapInstance = miniMap;
                  
                    miniMap.once('rendercomplete', () => {
                      miniMap.updateSize();  // Ensure map size is updated after rendering
                      ////logger.log(`Mini-map created and centered at Latitude: ${latitude}, Longitude: ${longitude}`);
                    });

                  } else {
                    // If the map already exists, just update the view center
                    const miniMapView = existingMiniMap.getView();
                    miniMapView.setCenter(fromLonLat([longitude, latitude]));
                    miniMapView.setZoom(15);  // Adjust zoom level if necessary
                  
                    ////logger.log(`Mini-map updated and centered at Latitude: ${latitude}, Longitude: ${longitude}`);
                  }

                } else {
                  ////logger.log('Invalid latitude or longitude data for centering the map.');
                }
              
                ////logger.log(`Skipping chart creation for sensor: ${sensor.title}`);
                continue; // Skip this iteration and move to the next sensor
            }

            if (sensor.title.toLowerCase().includes('crowd distribution') || sensor.title.toLowerCase().includes('sma')) {
              logger.log(`Skipping chart creation for sensor: ${sensor.title}`);
              continue; // Skip to the next sensor
            };

            const prepareScenarioData = (scenarioData, selectedDate) => {
              const adjustedTimestamps = new Set(); // Track used timestamps to avoid duplicates
            
              logger.log("Scenario Data: ", scenarioData);
            
              // ✅ Step 1: Sort by Original Timestamp
              const sortedData = scenarioData.slice().sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
            
              // ✅ Step 2: Adjust Time Using relative_time (in minutes)
              const adjustedData = sortedData.map(data => {
                let baseDate = new Date(selectedDate); // Start with the selectedDate at 12:00 noon
                baseDate.setHours(12, 0, 0, 0); // Reset time to noon
            
                // Apply relative_time (subtract minutes from noon)
                baseDate.setMinutes(baseDate.getMinutes() + data.relative_time); // If negative, it moves backward
            
                // Ensure unique timestamp by checking the adjustedTimestamps set
                while (adjustedTimestamps.has(baseDate.toISOString())) {
                  baseDate.setMinutes(baseDate.getMinutes() - 1); // Shift back 1 minute to ensure uniqueness
                }
            
                // Add the adjusted timestamp to the set
                adjustedTimestamps.add(baseDate.toISOString());
            
                // ✅ Return adjusted scenario data with only hours and minutes
                return {
                  ...data,
                  timestamp: baseDate.toISOString()
                };
              });
            
              // ✅ Step 3: Return Data Sorted Chronologically Again
              return adjustedData.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
            };            

            // const filterLiveData = async (liveData, selectedDate) => {
            //   // Parse the selected date and define start and end range
            //   const selected = new Date(selectedDate);
            //   selected.setHours(12, 0, 0, 0); // Set time to noon for accurate comparison
            
            //   const dayBefore = new Date(selected);
            //   dayBefore.setDate(dayBefore.getDate() - 1); // Previous day
            
            //   const dayAfter = new Date(selected);
            //   dayAfter.setDate(dayAfter.getDate() + 1); // Next day
            
            //   // Filter live data to include only timestamps within the range
            //   return liveData.filter(data => {
            //     const dataDate = new Date(data.timestamp);
            //     dataDate.setHours(12, 0, 0, 0); // Normalize data timestamp to noon
            
            //     return (
            //       dataDate.getTime() === dayBefore.getTime() ||
            //       dataDate.getTime() === selected.getTime() ||
            //       dataDate.getTime() === dayAfter.getTime()
            //     );
            //   });
            // };

           
          const renderEChartsChart = (sensor, liveData, scenarioData, units, minDate) => {
            let chartContainer = document.getElementById(`chart-${sensor.id}`);

            // Create the container if it doesn't exist
            if (!chartContainer) {
              chartContainer = document.createElement('div');
              chartContainer.id = `chart-${sensor.id}`;
              chartContainer.style.width = '100%';
              chartContainer.style.height = '400px';
              chartContainer.style.margin = '20px 0';
              document.getElementById('sidebar-content').appendChild(chartContainer);
            }
          
            const existingChart = echarts.getInstanceByDom(chartContainer);
            if (existingChart) {
              existingChart.dispose();
              //logger.log("Existing ECharts instance disposed.");
            }
          
            // Function to check visibility
            const isVisible = () => {
              const style = getComputedStyle(chartContainer);
              return (
                chartContainer.clientWidth > 0 &&
                chartContainer.clientHeight > 0 &&
                style.display !== 'none' &&
                style.visibility !== 'hidden'
              );
            };
          
            // Initialize Chart
            const initializeChart = () => {
              if (!isVisible()) {
                //logger.warn("Chart container is not visible or has zero dimensions. Skipping initialization.");
                return;
              }

              const matchingUnit = units.find(unit => unit.id === sensor.unit);

              const unitCode = matchingUnit ? matchingUnit.code : null; // Store unit.code if found

              logger.log("✅ Unit Code:", unitCode);

              const liveSeries = {
                name: 'Live Data',
                type: 'line',
                data: liveData.map(data => [data.timestamp, data.value]),
                smooth: true,
                connectNulls: false,
                lineStyle: {
                  width: 2,
                  color:'#4bc0c0',
                },
                itemStyle: {
                  color: '#4bc0c0' // First scenario points are red
                },
              };
            
              const scenarioGroups = scenarioData.reduce((groups, data) => {
                const scenarioName = data.scenario || 'Default Scenario';
                if (!groups[scenarioName]) {
                  groups[scenarioName] = [];
                }
                groups[scenarioName].push([data.timestamp, data.value]);
                return groups;
              }, {});

              const scenarioSeries = Object.keys(scenarioGroups).map((scenarioName, index) => ({
                  name: `Scenario: ${scenarioName}`,
                  type: 'line',
                  data: scenarioGroups[scenarioName],
                  smooth: true,
                  connectNulls: false,
                  lineStyle: {
                    width: 2,
                    type: 'dashed',
                    color: index === 0 ? '#FF0000' : undefined,
                  },
                  itemStyle: {
                    color: index === 0 ? '#FF0000' : undefined, // First scenario points are red
                  },
                }));

              const series = [liveSeries, ...scenarioSeries];

              const isEmpty = liveData.length === 0 && scenarioData.length === 0;
          
              const options = {
                title: {
                  text: `Sensor Data: ${sensor.title}`,
                  left: 'center'
                },
                tooltip: {
                  trigger: 'axis',
                  axisPointer: { type: 'cross' },
                  formatter: function (params) {
                    let result = `${new Date(params[0].value[0]).toISOString().split('T')[0]}<br/>`; // YYYY-MM-DD
                
                    params.forEach((item) => {
                      const utcTime = new Date(item.value[0]).toISOString().split('T')[1].slice(0, 5); // HH:MM in UTC
                      result += `${item.marker} ${item.seriesName} at: ${utcTime} UTC<br/>`;
                    });
                
                    return result;
                  }
                },
                legend: {
                  data: ['Live Data', ...Object.keys(scenarioGroups).map(scenario => `Scenario: ${scenario}`)],
                  bottom: 0
                },
                xAxis: {
                  type: 'time',
                  name: 'HH:MM',
                  boundaryGap: false,
                  axisLabel: {
                    formatter: function (value) {
                      return new Date(value).toISOString().split('T')[1].slice(0, 5); // Keep HH:MM in UTC
                    },
                  }
                },
                yAxis: {
                  type: 'value',
                  name: unitCode
                },
                series: isEmpty ? [] : series,  // ✅ If empty, remove series
                graphic: isEmpty
                  ? [
                      {
                        type: 'text',
                        left: 'center',
                        top: 'middle',
                        style: {
                          text: `No Data Available At: ${minDate.toISOString().split('T')[0]} - ${selectedDateRef.current}`,
                          fontSize: 18,
                          fontWeight: 'bold',
                          fill: 'gray',
                          textAlign: 'center'
                        }
                      }
                    ]
                  : [],
                dataZoom: [
                  {
                    type: 'slider',
                    show: true,
                    xAxisIndex: 0,
                    start: 0,
                    end: 100,
                    realtime: true,
                    handleSize: '100%',
                    height: 20,
                    bottom: 10
                  },
                  {
                    type: 'inside',
                    xAxisIndex: 0
                  }
                ]
              };

              const existingChart = echarts.getInstanceByDom(chartContainer);
              if (existingChart) {
                logger.log("⚠️ Chart already exists, skipping initialization.");
                return;
              }
              
              const chart = echarts.init(chartContainer);
          
              chart.setOption(options);
              //logger.log("ECharts initialized successfully!");
            };
          
            const initializedCharts = new Set(); // Tracks initialized charts

            const initializeOnce = (container, sensorData) => {
              if (initializedCharts.has(container.id)) {
                logger.log(`🚫 Chart already initialized: ${container.id}`);
                return;
              }
            
              if (!sensorData || sensorData.length === 0) {
                logger.log(`⏳ Waiting for sensor data before initializing ${container.id}`);
                return;
              }
            
              initializedCharts.add(container.id); // Mark chart as initialized
              logger.log(`✅ ECharts initialized successfully for ${container.id}`);
              initializeChart();
            };
            
            // ✅ Use ONLY IntersectionObserver
            const observer = new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                if (entry.isIntersecting && isVisible() && !initializedCharts.has(chartContainer.id)) {
                  initializeOnce(chartContainer, sensorData);
                  observer.disconnect(); // Stop observing after the first initialization
                }
              });
            });
            
            // Start observing the chart container
            observer.observe(chartContainer);            
            
          };


            // Inside your feature selection logic
            if (sensorData.length > 0) {
              // Separate Live Data and Scenario Data
              const selected = new Date(selectedDateRef.current);
              selected.setHours(23, 59, 59, 999); // Normalize to start of the selected day

              const minDate = new Date(selected);
              minDate.setDate(minDate.getDate() - 2); // Move 2 days back

              // logger.log("selected date: ", selectedDate);
              // logger.log("selected const: ", selected);
              // logger.log("min date: ", minDate);


              const liveData = sensorData.filter(data => {
                const dataDate = new Date(data.timestamp);
                logger.log("data timestamp: ", dataDate);
                return (
                  data.scenario === null &&
                  data.sensor === sensor.id &&
                  dataDate >= minDate &&  // ✅ Data must be within the last 2 days
                  dataDate <= selected    // ✅ Data must not be in the future
                );
              });
              // const preparedLiveData = await filterLiveData(liveData, selectedDate);
            
              const scenarioData = sensorData.filter(data => data.scenario !== null && data.sensor === sensor.id); // Ensure scenario matches sensor ID
            
              // console.log(`Sensor ID: ${sensor.id}`);
              // console.log('Live Data:', liveData);
              // console.log('Prepared Live Data:', preparedLiveData);
              // console.log('Scenario Data:', scenarioData);

              let samariaGorgeFeature = null; // Store the feature

              mapRef.current.getLayers().forEach(layer => {
                if (layer instanceof VectorLayer) { // Only check vector layers
                  const source = layer.getSource();
                  source.forEachFeature(feature => {
                    if (feature.get('title') === "Greek Pilot Area - Samaria Gorge Bounding Box") {
                      samariaGorgeFeature = feature;
                      logger.log("✅ Found Feature:", samariaGorgeFeature);
                    }
                  });
                }
              });

              const statesResponse = await fetchDataStates()
              const units = await fetchDataUnits()

              const matchingState = statesResponse.find(state => state.id === samariaGorgeFeature.get('state'));
              logger.log("✅ Matching State:", matchingState);
            
              // Prepare scenario data
              const preparedScenarioData =
                matchingState.title === "Fire Confirmed"
                  ? prepareScenarioData(scenarioData, selectedDateRef.current) // Run as usual
                  : [];

              logger.log('Prepared Scenario Data:', preparedScenarioData);
            
              // Pass filtered and prepared data to the chart
              if (liveData) {
                renderEChartsChart(sensor, liveData, preparedScenarioData, units, minDate);
              }
            }
          }
          map.removeOverlay(loaderOverlay);
          sidebar.classList.remove('hidden');
        } catch (error) {
          //logger.error("Error fetching sensors:", error);

          // Get the geometry and transform coordinates to EPSG:4326
          const geometry = selectedFeature.getGeometry();
          const [longitude, latitude] = geometry.getCoordinates();
          const [lon, lat] = transform([longitude, latitude], 'EPSG:3857', 'EPSG:4326');
        
          // Update the sidebar content using the selected feature properties
          const descriptionElement = document.getElementById('sidebar-description');
          const imgElement = document.getElementById('sidebar-image');
          const sidebarTitle = document.getElementById('sidebar-title');
        
          sidebarTitle.innerHTML = properties.title || 'No Title';
          descriptionElement.innerHTML = properties.description || 'No Description Available';
          
          if (imgElement) {
            imgElement.src = properties.image || ''; // Set the image URL from properties.image
            imgElement.alt = `Image for ${properties.title || 'No Title'}`;
          }

          const sidebarContent = document.getElementById('sidebar-content');
          sidebarContent.innerHTML = '';
        
          // Display the coordinates (latitude and longitude)
          sidebarContent.innerHTML += `
            <p><strong>Coordinates:</strong> Latitude: ${lat}, Longitude: ${lon}</p><br/><br/>
            <h4>No Sensor Data Available</h4>
          `;
          hasRun = false;
          map.removeOverlay(loaderOverlay);
          sidebar.classList.remove('hidden');  // Ensure the sidebar is visible
        }
      } else {
        ////logger.log("Selected Samaria Pilot Area");
      }
    } else {
      const infoElement = document.getElementById('info-element');
      if (infoElement) {
        infoElement.style.display = 'none'; // Hide the element when no feature is selected
      }
    }
  }

  // This useEffect will run after data has been fetched
  useEffect(() => {
    if (dataFetched && mapRef.current) { // Only add layers if data is fetched
      sources.forEach(source => {
        if (source.title.startsWith('GPS') || source.title.startsWith('IPS')) {
          const correspondingLayer = layers.find(layer => layer.source === source.id);

          const layerData = createLayerFromSource(source, correspondingLayer);  // Create the layer
          if (layerData) {
            const { layer, vectorSource } = layerData;

            // Add the layer to the map
            if (layer) {
              mapRef.current.addLayer(layer);
              ////logger.log(`Layer added to the map for source: ${source.title}`);
            }

            // Add features to the vector source if it exists
            if (vectorSource) {
              addFeaturesToSource(features, vectorSource, source, projections, selectedDate);  // Pass the vector source directly
              ////logger.log("Features added to source:", vectorSource.getFeatures());
            }
          } else {
            ////logger.log(`No layer created for source: ${source.title}`);
          }
        }
      });
    }
  }, [dataFetched]); // Triggered only when data has been fetched

  useEffect(() => {
    // Function to fetch data and update states every 5 seconds
    const fetchDataAndUpdate = async () => {
      try {
        // Fetch all necessary data directly (features, sources, and data states)
        const [sourcesResponse, layersResponse, featuresResponse, sourceParamsResponse, statesResponse] = await Promise.all([
          fetchSources(),
          fetchLayers(),
          fetchFeatures(),
          fetchSourceParameters(),
          fetchDataStates(),
        ]);
  
        // Set the responses into their respective states
        setSources(sourcesResponse);
        setLayers(layersResponse);
        setFeatures(featuresResponse);
        setSourceParameters(sourceParamsResponse);
        setStates(statesResponse);
  
        ////logger.log('Sources fetched:', sourcesResponse);
        ////logger.log('Layers fetched:', layersResponse);
        ////logger.log('Features fetched:', featuresResponse);
        ////logger.log('Source Parameters fetched:', sourceParamsResponse);
        ////logger.log('States fetched:', statesResponse);

          const viewExtent = mapRef.current.getView().calculateExtent(mapRef.current.getSize());
          //logger.log("Map Layers: ", mapRef.current.getLayers().getArray());

          // Find the Greek and Italian Pilot layers based on title
          const greekPilotLayer = mapRef.current.getLayers().getArray().find(layer => 
            layer.values_.title?.includes('GPS - Greek Pilot Area')
          );
          const italianPilotLayer = mapRef.current.getLayers().getArray().find(layer => 
              layer.values_.title?.includes('IPS - Italian Pilot Area')
          );
          const greekPilotFeature = greekPilotLayer?.getSource().getFeatures()[0]; 
          const italianPilotFeature = italianPilotLayer?.getSource().getFeatures()[0];
          //logger.log("Greek Pilot Layer: ", greekPilotLayer);
          //logger.log("Greek Pilot Feature: ", greekPilotFeature);
          //logger.log("Italian Pilot Layer: ", italianPilotLayer);
          //logger.log("Italian Pilot Feature: ", italianPilotFeature);


          // Function to find the feature extent and update the info box
          const updateInfoBox = (feature) => {
              let infoElement = document.getElementById('info-element');
              
              if (!infoElement) {
                  infoElement = document.createElement('div');
                  infoElement.id = 'info-element';
                  infoElement.style.position = 'fixed';
                  infoElement.style.left = '100px';
                  infoElement.style.bottom = '100px';
                  infoElement.style.zIndex = '1000';
                  infoElement.style.backgroundColor = 'rgba(56, 65, 81, 0.9)';
                  infoElement.style.color = 'white';
                  infoElement.style.width = '250px';
                  infoElement.style.padding = '10px';
                  infoElement.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.2)';
                  document.body.appendChild(infoElement);
              } else {
                infoElement.style.display = 'box';
              }

              if (feature.length === 2) {
                infoElement.innerHTML = `
                  <strong>Both pilot areas are visible</strong><br><br>
                  Zoom in to focus on either the <strong>Greek Pilot Area</strong> or the <strong>Italian Pilot Area</strong>.
                `;
                return;
              }

              // Update the content of the info box
              const title = feature.values_.title || 'No Title';
              const description = feature.values_.description || 'No Description';
              const address = feature.values_.address || 'No Address';
              const featureStateId = feature.values_.state;
              const featureState = statesResponse.find(state => state.id === featureStateId);
              const stateIcon = featureState?.icon || '';
              const stateColor = featureState?.color || 'white';
              const stateTitle = featureState?.title || '';

              infoElement.innerHTML = `
                  ${stateIcon ? `<i class="${stateIcon}" style="color:${stateColor}; font-size: 18px;"></i> <span style="color:${stateColor};">${stateTitle}</span><br/><br/>` : ''}
                  <strong>${title}</strong><br/><br/>
                  ${description}<br/><br/>
              `;
              //<small><strong>Address:</strong> ${address}</small>
          };

           // Check if both features intersect
          const greekIntersects = greekPilotFeature && intersects(viewExtent, greekPilotFeature.getGeometry().getExtent());
          const italianIntersects = italianPilotFeature && intersects(viewExtent, italianPilotFeature.getGeometry().getExtent());

          if (greekIntersects && italianIntersects) {
              //logger.log("Both Greek and Italian Pilot Areas Intersect with View");
              updateInfoBox([greekPilotFeature, italianPilotFeature]);
          } else if (greekIntersects) {
              //logger.log("Greek Pilot Area Intersects with View")
              updateInfoBox(greekPilotFeature);
          } else if (italianIntersects) {
              //logger.log("Italian Pilot Area Intersects with View")
              updateInfoBox(italianPilotFeature);
          } else {
              // Hide the info box if neither feature is in view
              //logger.log("No Area Itersects with View")
              const infoElement = document.getElementById('info-element');
              if (infoElement) {
                  infoElement.remove();
              }
          }
  
        // Get the current vector layers from the map
        const vectorLayers = mapRef.current.getLayers().getArray().filter(layer => layer instanceof VectorLayer);
    
        // Remove all features from the map (but keep sources/layers intact)
        vectorLayers.forEach(layer => {
          const source = layer.getSource();
          source.clear();  // This removes all features from the vector source
          ////logger.log("All features removed from the layer:", layer);

          mapRef.current.removeLayer(layer);
          ////logger.log("Layer removed from the map:", layer);
        });
    
        // Re-add the layers and features using the fetched data
        sourcesResponse.forEach(source => {
          if (source.title.startsWith('GPS') || source.title.startsWith('IPS')) {
            // ////logger.log(`Processing source ${source.title} with ID: ${source.id}`);

            // // Log fetchedLayers to understand the structure and inspect source matching
            // ////logger.log("Available Layers:", fetchedLayers);

            const correspondingLayer = layersResponse.find(layer => layer.source === source.id);
            ////logger.log("Corresponding Layer:", correspondingLayer);

            // if (!correspondingLayer) {
            //   ////logger.warn(`No corresponding layer found for source ${source.title} with ID: ${source.id}`);
            //   return;
            // }
            const layerData = createLayerFromSource(source, correspondingLayer, statesResponse);  // Create the layer
            if (layerData) {
              const { layer, vectorSource } = layerData;
  
              // Add the layer to the map if it doesn't already exist
              if (!mapRef.current.getLayers().getArray().includes(layer)) {
                mapRef.current.addLayer(layer);
                ////logger.log(`Layer added to the map for source: ${source.title}`);
              }
  
              // Add the new features to the vector source
              if (vectorSource) {
                addFeaturesToSource(featuresResponse, vectorSource, source, projections, selectedDate);  // Pass the vector source directly
                ////logger.log("Features added to source:", vectorSource.getFeatures());
              }
            } else {
              ////logger.log(`No layer created for source: ${source.title}`);
            }
          }
        });
      } catch (error) {
        ////logger.error('Error fetching or updating features:', error);
      }
    };
  
    // Fetch data immediately when the component mounts
    // fetchDataAndUpdate();
  
    // Set up an interval to fetch data every 5 seconds
    const intervalId = setInterval(() => {
      fetchDataAndUpdate();
    }, 5000);  // 5000 ms = 5 seconds
  
    // Cleanup interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [selectedDate]);

  return (
    <>
      {/* Map container */}
      <div id="map"></div>
      {/* <div id="map" style={{ width: '100%', height: '100vh', zIndex: 0 }}></div>  // Ensure the map div has proper height and width */}
      <SideBar
        mapRef={mapRef}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        setHoveredButtonInfo={setHoveredButtonInfo}            
        toggleDrawer={toggleDrawer}
      />
      {/* Information Drawer */}
      <div>
        <div className={`information-container ${isDrawerOpen ? 'open' : ''}`}>
          <div className="title">
            <h2>Instructions</h2>
          </div>
          <div className="information-content">
            {/* Render HTML content dynamically */}
            <p dangerouslySetInnerHTML={{ __html: hoveredButtonInfo }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Monitoring;